import type { Components, Theme } from '@mui/material/styles';

/**
 * `labelPlacement="start"` rows (e.g. AQI alert toggles). MUI defaults include
 * `marginRight: -11`, which bleeds past the container when the switch is 44px wide.
 */
export const MuiFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { labelPlacement: 'start' },
          style: {
            marginLeft: 0,
            marginRight: 0,
          },
        },
      ],
    },
  },
};
